/** blog.JS For the Blog page **/

/* Initialize */
var infoLinks = document.querySelectorAll('.topic_link');

/* Listeners */
infoLinks.forEach((link)=>{
    link.addEventListener('mouseenter', (e)=>{
        var linkVal = link.getAttribute('data-value');

        $('.more_info').hide(0);
        $('.more_info-' + linkVal).fadeIn(300);
        
    })
    link.addEventListener('mouseleave', (e)=>{
        $('.more_info').fadeOut(300);
    })
})